/**
 * @generated SignedSource<<cd5b818af4c6da3de97a876ff0e3ce06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DisablePipedriveInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DisablePipedriveMutation$variables = {
  input: DisablePipedriveInput;
};
export type DisablePipedriveMutation$data = {
  readonly disablePipedrive: {
    readonly company: {
      readonly pipedriveCompanyDomain: string | null;
    } | null;
  } | null;
};
export type DisablePipedriveMutation = {
  variables: DisablePipedriveMutation$variables;
  response: DisablePipedriveMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pipedriveCompanyDomain",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DisablePipedriveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisablePipedrivePayload",
        "kind": "LinkedField",
        "name": "disablePipedrive",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DisablePipedriveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisablePipedrivePayload",
        "kind": "LinkedField",
        "name": "disablePipedrive",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2c587d58f17abe8efeef2681e37af7d3",
    "id": null,
    "metadata": {},
    "name": "DisablePipedriveMutation",
    "operationKind": "mutation",
    "text": "mutation DisablePipedriveMutation(\n  $input: DisablePipedriveInput!\n) {\n  disablePipedrive(input: $input) {\n    company {\n      pipedriveCompanyDomain\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d124ffde2790ccbdc6fad915345b29a7";

export default node;
